import { useRef, useEffect } from 'react'

/***
 * Utility for being able to compare a previous value
 * to a new one
 * @param value
 */

export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>()

  useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}
